import { useState } from "react";
import CampaignList from "./CampaignList";
import ClientNavigation from "./ClientNavigation";
import StatCard from "./StatCard";

import "../assets/css/Insights.css";

function Insights() {
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [priorityCounts, setPriorityCounts] = useState({
    P1: 0,
    P2: 0,
    NORMAL: 0,
  });
  const [selectedPriority, setSelectedPriority] = useState(null);

  const handleCampaignClick = (campaign) => {
    setSelectedCampaign(campaign);
  };

  const handleRefresh = () => {
    setIsRefreshing(true);

    setLastUpdated(new Date());

    setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  };

  const handleCampaignsLoaded = (campaigns) => {
    const counts = { P1: 0, P2: 0, NORMAL: 0 };

    campaigns.forEach((c) => {
      const rawPriority = (c.prioridade || "").toString().trim().toLowerCase();

      if (rawPriority.includes("p1")) {
        counts.P1++;
      } else if (rawPriority.includes("p2")) {
        counts.P2++;
      } else if (rawPriority.includes("normal")) {
        counts.NORMAL++;
      }
    });

    setPriorityCounts(counts);
  };

  return (
    <div className="insights-content">
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap"
        rel="stylesheet"
      />

      {!selectedCampaign ? (
        <>
          <ClientNavigation />
          <div className="stat-cards-container">
            <StatCard
              title="Campanhas com Prioridade P1"
              value={priorityCounts.P1}
              onClick={() => { setSelectedPriority("p1"); }}
            />
            <StatCard
              title="Campanhas com Prioridade P2"
              value={priorityCounts.P2}
              onClick={() => setSelectedPriority("p2")}
            />
            <StatCard
              title="Campanhas com Prioridade Normal"
              value={priorityCounts.NORMAL}
              onClick={() => setSelectedPriority("normal")}
            />
          </div>
          <div className="campaigns-container">
            <div className="campaigns-header">
              <div className="campaigns-title">
                <div className="title-text">Campanhas ativas</div>
                <div className="subtitle-text">
                  Mostrando todas suas campanhas ativas
                </div>
              </div>
              <div className="filter-controls">
                {selectedPriority && (
                  <div className="filter-indicator" onClick={() => setSelectedPriority(null)}>Remover filtro</div>
                )}
                <button className="icon-button" onClick={handleRefresh}>
                  <i className={`ti ti-refresh ${isRefreshing ? "rotating" : ""}`}></i>
                </button>
              </div>
            </div>

            <CampaignList
              lastUpdated={lastUpdated}
              onCampaignClick={handleCampaignClick}
              onCampaignsLoaded={handleCampaignsLoaded}
              filterByPriority={selectedPriority}
            />
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default Insights;
